export function headerAnimations() {
  if (typeof gsap === "undefined") {
    console.warn("GSAP not found. Submenu animation skipped.");
    return;
  }

  const navbar = document.querySelector("#wrapper-navbar");
  if (!navbar) {
    console.warn("headerAnimations: #wrapper-navbar not found.");
    return;
  }

  // ✅ FIX 1: Search the entire document for .subpage-menu,
  // not just inside the nav — it's rendered as a sibling element outside #main-nav
  const submenu = document.querySelector(".subpage-menu");

  if (!submenu) {
    console.warn("headerAnimations: .subpage-menu not found in document.");
    return;
  }

  // ✅ FIX 2: Scope menu triggers to the navbar only (language-agnostic)
  // Polylang may render #menu-primary-deutsch, #menu-primary, etc.
  const triggers = gsap.utils.toArray(
    navbar.querySelectorAll(".menu-item-has-children > a")
  );

  if (!triggers.length) {
    console.warn("headerAnimations: No .menu-item-has-children triggers found.");
    return;
  }

  // ✅ FIX 3: listItems are inside .subpage-menu, so query from there
  const listItems = gsap.utils.toArray(
    submenu.querySelectorAll(".child-pages-list li")
  );

  gsap.set(submenu, { autoAlpha: 0, height: 0, overflow: "hidden" });
  gsap.set(listItems, { autoAlpha: 0, y: 20 });

  triggers.forEach(trigger => {
    const parentItem = trigger.closest(".menu-item-has-children");

    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      gsap.killTweensOf([submenu, ...listItems]);

      const isOpen = submenu.classList.contains("active");

      if (isOpen) {
        gsap.to(listItems, { autoAlpha: 0, y: 20, duration: 0.15, ease: "power2.in" });
        gsap.to(submenu, {
          autoAlpha: 0,
          height: 0,
          duration: 0.3,
          ease: "power2.in",
          onComplete: () => gsap.set(listItems, { autoAlpha: 0, y: 20 }),
        });

        submenu.classList.remove("active");
        parentItem.classList.remove("active");
        trigger.classList.remove("active");
        trigger.setAttribute("aria-expanded", "false");
      } else {
        // ✅ FIX 4: Temporarily make visible to measure scrollHeight accurately
        gsap.set(submenu, { autoAlpha: 0, height: "auto", overflow: "hidden" });
        const fullHeight = submenu.scrollHeight;
        gsap.set(submenu, { height: 0 });

        gsap.to(submenu, {
          autoAlpha: 1,
          height: fullHeight,
          duration: 0.3,
          ease: "power2.out",
        });
        gsap.to(listItems, {
          autoAlpha: 1,
          y: 0,
          duration: 0.5,
          ease: "power2.out",
          stagger: 0.08,
          delay: 0.1,
        });

        submenu.classList.add("active");
        parentItem.classList.add("active");
        trigger.classList.add("active");
        trigger.setAttribute("aria-expanded", "true");
      }
    });
  });

  // Close on outside click
  document.addEventListener("click", (e) => {
    // ✅ FIX 5: Check both navbar AND submenu (since submenu is outside navbar)
    if (
      !navbar.contains(e.target) &&
      !submenu.contains(e.target) &&
      submenu.classList.contains("active")
    ) {
      gsap.killTweensOf([submenu, ...listItems]);
      gsap.to(listItems, { autoAlpha: 0, y: 20, duration: 0.15, ease: "power2.in" });
      gsap.to(submenu, {
        autoAlpha: 0,
        height: 0,
        duration: 0.3,
        ease: "power2.in",
        onComplete: () => gsap.set(listItems, { autoAlpha: 0, y: 20 }),
      });

      submenu.classList.remove("active");
      navbar.querySelectorAll(".menu-item-has-children").forEach(item => {
        item.classList.remove("active");
        const a = item.querySelector(":scope > a");
        if (a) {
          a.classList.remove("active");
          a.setAttribute("aria-expanded", "false");
        }
      });
    }
  });
}